<div>
	<caass-ri-job-table (JobSelected)="onJobSelected($event)"></caass-ri-job-table>
</div>

<div>
	<caass-ri-job-schedule-table [SelectedJob]="SelectedJob"></caass-ri-job-schedule-table>
</div>

<div>
	<caass-ri-job-recipients-table [SelectedJob]="SelectedJob"></caass-ri-job-recipients-table>
</div>
